module.exports = __webpack_public_path__ + "img/shrubs_grey_en.91553000.svg";